/*eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

// import authentication from './authenticate'

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    // authentication,
  }
})